// Colour used for every edge on the Field Mapper canvas (cloud primary blue).
export const EDGE_COLOR = '#437fed';

// Colour of an edge that has been drawn but not saved yet.
export const UNSAVED_EDGE_COLOR = '#e5383b';
